import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ExamRefListRecord from "../../components/ExamRefListRecord";
import {
	xhrClinicalGetExamStudyByExamId,
	xhrClinicalGetPatHistoryExamsRef
} from "../../utilities/xhr-clinical";
import {
	xhrTenantGetDoctorsByInstitutionIds,
} from "../../utilities/xhr-tenant";
import ExamBottomSection from "../../components/ExamBottomSection";
import translator from "../../utilities/translator.js";
import toastUtil from "../../utilities/toast-util";

function PatientHistoryTab({ patient }) {
	const params = useParams();
	const history = useHistory();
	const mountRef = React.useRef(true);
	const token = useSelector((state) => state.session.token);
	
	const [sortBy, setSortBy] = React.useState("Date");
	const [sortDirection, setSortDirection] = React.useState("DESC");

	const [PatHistoryExams, setPatHistoryExams] = React.useState();
	
	const loadPatHistoryExams = React.useCallback(async (s,e) => {
		if(patient){
			var data = await xhrClinicalGetPatHistoryExamsRef(token, patient?.id,sortBy,sortDirection);
			setPatHistoryExams(data?.result?.data);
		}
	}, [token, patient?.id, sortBy,sortDirection]);
	
	React.useEffect(() => {
		loadPatHistoryExams();
	}, [sortBy, sortDirection, patient]);
	
	React.useEffect(() => {
		if (patient?.id && mountRef.current) {
			loadPatHistoryExams();
		}
		return () => {
			mountRef.current = false;
		};
	}, [patient?.id]);
	
	const currentLanguage = useSelector((state) => state.session?.userPreferences?.language);

	const currentTenantID = patient?.tenantId;

	const [doctorList, setDoctorList] = React.useState([]);

	React.useEffect(() => {
		let mountedRef = true;
		if (PatHistoryExams){
			
		const effectPromise = async () => {
			var data = await xhrTenantGetDoctorsByInstitutionIds(token, { ids: PatHistoryExams?.map((x) => x.instId).filter((v, i, a) => a.indexOf(v) === i)});
			toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				let users = [];
				Object.entries(data?.result?.data??[]).forEach(entry => {
					const [key, value] = entry;
					for (const instId of (value?.entIds??[])) {
						if(users[instId]){
							users[instId].push(value.user);
						}else{
							users[instId] = [value.user];
						}
						
						users[instId] = users[instId].sort((a, b) => (a.userDisplayName < b.userDisplayName) ? -1 : 1)
					}
				});
				setDoctorList(users);
			}
			effectPromise();
		}
	}, [PatHistoryExams]);

	const [selectedExamObj, setCurrentSelectedExam] = React.useState(null);

	// update selected exam if exam list updates
	React.useEffect(() => {
		if (PatHistoryExams?.length && selectedExamObj) {
			const foundExam = PatHistoryExams.find(
				(x) => x.id === selectedExamObj.id
			);
			if (foundExam) {
				setCurrentSelectedExam(foundExam);
			}
		}
	}, [PatHistoryExams, selectedExamObj]);

	const [ExamStudyByExamId, setExamStudyByExamId] = React.useState();
	React.useEffect(() => {
		let mountedRef = true;
		if (selectedExamObj?.id) {
			
		const effectPromise = async () => {
				var data = await xhrClinicalGetExamStudyByExamId(token, selectedExamObj.id);
			toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setExamStudyByExamId(data?.result?.data);
			}
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [selectedExamObj, token]);


	return (
		<div className="phistory-inner d-flex flex-column" style={{ height: '100%' }}>
				<div className="table-full-width table-tasks table-res custom-scroll light-background border-radius-4 ph-table" style={{ overflow: 'auto'}}>
					<table className="table fav-list-table  table-headingfix">
						<thead className="bg-customdark">
							<tr className="bg-customdark">
								<th width="110px">
									<button
										className="btn font-sfpro bg-transparent primary-color font-14 p-0 capital"
										onClick={(e) => {
											setSortBy("Date");
											setSortDirection("ASC");
										}}
									>
										reset
									</button>
								</th>
								<th width="95px">
									<button
										className="btn font-sfpro bg-transparent text-white font-14 mr-2 capital"
										onClick={(e) => {
											setSortBy("Date");
											setSortDirection((dir) => (dir === "ASC" ? "DESC" : "ASC"));
										}}
									>
										date
										<i
											className={"fa fa-long-arrow-down ml-1 " + ( sortBy === "Date" && sortDirection === "DESC" ? "primary-color" : "")}
											aria-hidden="true"
										></i>
										<i
											className={"fa fa-long-arrow-up " + ( sortBy === "Date" && sortDirection === "ASC" ? "primary-color" : "")}
											aria-hidden="true"
										></i>
									</button>
								</th>
								<th width="95px">
									<button
										className="btn font-sfpro bg-transparent text-white font-14 capital"
										onClick={(e) => {
											setSortBy("Urgent");
											setSortDirection((dir) => (dir === "ASC" ? "DESC" : "ASC"));
										}}
									>
										urgent
										<i
											className={"fa fa-long-arrow-down ml-1 " + ( sortBy === "Urgent" && sortDirection === "DESC" ? "primary-color" : "")}
											aria-hidden="true"
										></i>
										<i
											className={"fa fa-long-arrow-up " + ( sortBy === "Urgent" && sortDirection === "ASC" ? "primary-color" : "")}
											aria-hidden="true"
										></i>
									</button>
								</th>
								<th width=""> &nbsp; </th>
								<th className="text-white text-right font-14 font-sfpro capital">
									total:{" "}
									{PatHistoryExams?.length ? PatHistoryExams.length : "0"}
								</th>
							</tr>
						</thead>
						<tbody className="custom-scroll">
							{ PatHistoryExams?.length &&
								PatHistoryExams?.map((exam, index) => (
									<React.Fragment key={`exam-${index}`}>
										<ExamRefListRecord exam={exam} index={index} isSelected={selectedExamObj?.id === exam?.id} 
											doctorList={doctorList[exam.instId]} setSelectedExam={setCurrentSelectedExam} compactView={true} 
											updateExams={()=>{ 
												loadPatHistoryExams();
												}}/>
									</React.Fragment>
								))}
						</tbody>
					</table>
				</div>
				{selectedExamObj &&
					<ExamBottomSection exclude={['patient']} examList={PatHistoryExams} selectedExam={selectedExamObj} bundledExams={[selectedExamObj]} updateExams={()=>{ 
						loadPatHistoryExams();
					}} />
				}
		</div>
	);
}
export default PatientHistoryTab;
